import Vue from 'vue'
import Router from 'vue-router'
/* Admin */
import EditExercise from '@/components/admin/EditExercise.vue'
import Library from '@/components/admin/Library.vue'
import Classrooms from '@/components/admin/Classrooms.vue'
import Reports from '@/components/admin/Reports.vue'
import Tablets from '@/components/admin/Tablets.vue'
import Users from '@/components/admin/Users.vue'  // TODO super admin funcionality
// import Literature from '@/components/admin/Literature.vue'
import ExerciseManager from '@/components/exercises/ExerciseManager.vue'
/* Admin Group */
import Admin from '@/components/admin/group/AdminPanel.vue'
import Exercises from '@/components/admin/group/Exercises.vue'
import Classes from '@/components/admin/group/Classes.vue'
import EditExam from '@/components/admin/group/EditExam.vue'
import Gradebook from '@/components/admin/group/Gradebook.vue'
/* Client */
import Profile from '@/components/profile/Profile.vue'
import ProfileEdit from '@/components/profile/ProfileEdit.vue'
import profileGroupStats from '@/components/profile/ProfileGroupStats.vue'
import SetPassword from '../components/authentication/SetPassword.vue'
// import OldProblem from '@/components/exercises/OldProblem.vue'
import GroupList from '@/components/groups-v2/GroupList'
import GroupListOld from '@/components/groups/GroupList'
import Home from '@/components/home/Home.vue'
import PageNotFound from '@/components/errors/PageNotFound.vue'
import EquizHeader from '@/components/header/header.vue'
import ExamExercises from '@/components/exercises/ExamExercise.vue'
import StopCheating from '@/components/admin/StopCheating.vue'
import SolvingExam from '@/components/exercises/SolvingExam.vue'
import UserRating from '@/components/rating/UserRating.vue'
import RatingResults from '@/components/rating/RatingExamResults.vue'
/* Ankete */
import Features from '@/components/home/Features.vue'
/* Both */
import BaseTemplate from '@/components/templates/BaseTemplate.vue'
import ConfirmEmail from '@/components/authentication/ConfirmEmail.vue'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/home',
      component: EquizHeader,
      meta: {
      },
      children: [
        {
          path: 'profile',
          name: 'profile',
          component: Profile,
          meta: {
            forAuth: true
          }
        },
        {
          path: 'profileEdit',
          name: 'profileEdit',
          component: ProfileEdit,
          meta: {
            forAuth: true
          }
        },
        {
          path: 'profileGroupStats/:yearId',
          name: 'profileGroupStats',
          component: profileGroupStats,
          meta: {
            forAuth: true
          }
        },
        {
          path: 'features',
          name: 'features',
          component: Features,
          meta: {
            forAuth: true
          }
        },
        {
          path: 'groups',
          component: { template: '<router-view/>' },
          meta: {
            breadcrumb: 'pages.group.bannerName'
          },
          children: [
            {
              path: '',
              name: 'groupList',
              component: GroupList,
              meta: {
                forAuth: true
              }
            },
            {
              path: 'groups-old',
              name: 'groupListOld',
              component: GroupListOld,
              meta: {
                forAuth: true
              }
            },
            {
              path: ':gid/years/:yid/userRating',
              name: 'UserRating',
              component: UserRating,
              props: true,
              meta: {
                forAuth: true
              }
            },
            {
              path: ':gid/years/:yid/userRating/:uid',
              name: 'UserRatingById',
              component: UserRating,
              props: true,
              meta: {
                forAuth: true
              }
            },
            {
              path: ':gid/years/:yid/subgroups/:sid',
              component: { template: '<router-view/>' },
              meta: {
              },
              children: [
                {
                  path: '',
                  name: 'exercises',
                  component: Exercises,
                  props: true,
                  meta: {
                    forAuth: true
                  }
                },
/*                {
                  path: 'literature',
                  name: 'literatureUser',
                  component: Literature,
                  props: false,
                  meta: {
                    forAuth: true,
                    breadcrumb: 'pages.literature.bannerName'
                  }
                },
                {
                  path: 'exercises/:subgroup/:pid/:nid',
                  name: 'OldProblem',
                  component: OldProblem,
                  props: true,
                  meta: {
                    forAuth: true
                  }
                },
*/
                {
                  path: 'manage',
                  name: 'exerciseManager',
                  component: ExerciseManager,
                  props: true,
                  meta: {
                  }
                },
/*
                {
                  path: 'dailyChallenges/:dailyId/:exerciseVersionId/:nid',
                  name: 'dailyChallenge',
                  component: OldProblem,
                  props: true,
                  meta: {
                    forAuth: true
                  }
                },
*/
                {
                  path: 'StopCheating/classExams/:quizID/classrooms/:selectedClassroom',
                  name: 'StopCheating',
                  component: StopCheating,
                  props: true,
                  meta: {
                    forAuth: true
                  }
                },
                {
                  path: 'classExams/:classExamId',
                  name: 'classExam',
                  component: ExamExercises,
                  props: true,
                  meta: {
                    forAuth: true
                  }
                },

                {
                  path: 'ratingExams/:classExamId',
                  name: 'ratingExam',
                  component: ExamExercises,
                  props: true,
                  meta: {
                    forAuth: true
                  }
                },

                {
                  path: 'ratingResults/:attemptId',
                  name: 'ratingResults',
                  component: RatingResults,
                  props: true,
                  meta: {
                    forAuth: true
                  }
                },

                {
                  path: 'classExamsResults/:classExamId',
                  name: 'classExamResults',
                  component: ExamExercises,
                  props: true,
                  meta: {
                    forAuth: true
                  }
                }
                /*
                {
                  path: 'classExams/:classId/:examId/:nid',
                  name: 'classExam',
                  component: OldProblem,
                  props: true,
                  meta: {
                    forAuth: true
                  }
                }
                */
              ]
            }
          ]
        }
      ]
    },
    {
      path: '/admin', // TODO: forAuth for those route groups
      component: EquizHeader,
      children: [
        {
          path: 'users/:uid/profile',
          name: 'profileOfAdmin',
          component: Profile,
          props: true,
          meta: {
            forAuth: true
          }
        },
        {
          path: 'users/:uid/profileEdit',
          name: 'adminProfileEdit',
          component: ProfileEdit,
          meta: {
            forAuth: true
          }
        },
        {
          path: 'users/:uid/group/:yearId',
          name: 'adminProfileGroupStats',
          component: profileGroupStats,
          meta: {
            forAuth: true
          }
        },
        {
          path: 'library',
          name: 'library',
          component: Library,
          meta: {
            forAuth: true,
            breadcrumb: 'pages.exerciseList.library'
          }
        },
        {
          path: 'classrooms',
          name: 'classrooms',
          component: Classrooms,
          meta: {
            forAuth: true,
            breadcrumb: 'pages.classrooms.manageClassrooms'
          },
          children: [
            {
              path: 'StopCheating',
              name: 'StopCheating',
              component: StopCheating,
              props: true,
              meta: {
                forAuth: true,
                breadcrumb: 'pages.exerciseList.library'
              }
            }
          ]
        },
        {
          path: 'tablets',
          name: 'tablets',
          component: Tablets,
          meta: {
            forAuth: true,
            breadcrumb: 'pages.adminpanel.tablets.bannerName'
          }
        },
        {
          path: 'users',
          name: 'users',
          component: Users,
          meta: {
            forAuth: true,
            breadcrumb: 'pages.adminpanel.users.bannerName'
          }
        },
        {
          path: 'reports',
          component: { template: '<router-view/>' },
          meta: {
          },
          children: [
            {
              path: '',
              name: 'reports',
              component: Reports,
              meta: {
                forAuth: true,
                breadcrumb: 'pages.reports.exerciseReports'
              }
            },
            {
              path: ':nid',
              name: 'editexercise',
              component: EditExercise,
              props: true,
              meta: {
                forAuth: true
              }
            }
          ]
        },
        {
          path: 'groups',
          component: { template: '<router-view/>' },
          meta: {
            breadcrumb: 'pages.group.bannerName'
          },
          children: [
            {
              path: '',
              name: 'adminGroups',
              component: GroupList,
              meta: {
                forAuth: true
              }
            },
            {
              path: 'groups-old',
              name: 'adminGroupsOld',
              component: GroupListOld,
              meta: {
                forAuth: true
              }
            },
            {
              path: ':gid/years/:yid',
              component: { template: '<router-view/>' },
              props: true,
              meta: {
                // breadcrumb: 'pages.adminpanel.header.dashboard'
              },
              children: [
                {
                  path: '',
                  name: 'admin',
                  component: Admin,
                  props: true,
                  meta: {
                    forAuth: true
                  }
                },
                {
                  path: 'classes',
                  name: 'classes',
                  component: Classes,
                  props: true,
                  meta: {
                    forAuth: true
                  }
                },
                {
                  path: 'exams',
                  component: { template: '<router-view/>' },
                  meta: {
                  },
                  children: [
                    {
                      path: ':examId',
                      name: 'editExam',
                      component: EditExam,
                      props: true,
                      meta: {
                        forAuth: true
                      }
                    },
                    {
                      path: ':examId/solving',
                      name: 'solvingExamProgress',
                      component: SolvingExam,
                      props: true,
                      meta: {
                        forAuth: true
                      }
                    }
                  ]
                },
                {
                  path: 'subgroups/:sid',
                  component: { template: '<router-view/>' },
                  meta: {
                  },
                  children: [
                    {
                      path: '',
                      name: 'exercisesAdmin',
                      component: Exercises,
                      props: true,
                      meta: {
                        forAuth: true,
                        admin: true
                        // breadcrumb: 'pages.adminpanel.exercises.bannerName'
                      }
                    },
/*
                    {
                      path: 'literature',
                      name: 'literatureAdmin',
                      component: Literature,
                      props: false,
                      meta: {
                        forAuth: true,
                        admin: true,
                        breadcrumb: 'pages.literature.bannerName'
                      }
                    },
*/
                    {
                      path: 'classExams/:classExamId',
                      name: 'classExamAdmin',
                      component: ExamExercises,
                      props: true,
                      meta: {
                        forAuth: true,
                        admin: true
                      }
                    },
                    {
                      path: 'classExamsResults/:classExamId',
                      name: 'classExamResultsAdmin',
                      component: ExamExercises,
                      props: true,
                      meta: {
                        forAuth: true
                      }
                    }
/*
                    {
                      path: 'exercises/:subgroup/:pid/:nid',
                      name: 'adminExercise',
                      component: OldProblem,
                      props: true,
                      meta: {
                        forAuth: true
                      }
                    }
*/
                  ]
                },
                {
                  path: 'gradebook',
                  name: 'gradebook',
                  component: Gradebook,
                  props: true,
                  meta: {
                    forAuth: true
                  }
                }
              ]
            },
            {
              path: ':gid/years/:yid/userRating/:uid',
              name: 'UserRatingByIdAdmin',
              component: UserRating,
              props: true,
              meta: {
                forAuth: true
              }
            }
          ]
        }
      ]
    },
    {
      path: '',
      component: EquizHeader,
      children: [
        {
          path: '',
          component: BaseTemplate,
          meta: {
          },
          children: [
            {
              path: '/show/home/groups/:gid/years/:yid/subgroups/:sid',
              name: 'exercise.public',
              component: Exercises,
              props: true,
              meta: {
                simpleHeader: true
              }
            },
            {
              path: '/token/email/confirm/:token',
              name: 'password.confirm',
              component: ConfirmEmail,
              props: true,
              meta: {
                simpleHeader: true
              }
            },
            {
              path: '/token/password/set/:token',
              name: 'password.set',
              component: SetPassword,
              meta: {
                type: 'setPassword',
                simpleHeader: true
              }
            },
            {
              path: '/token/password/set-new/:token',
              name: 'password.setNew',
              component: SetPassword,
              meta: {
                type: 'setNewPassword',
                simpleHeader: true
              }
            },
            {
              path: '/',
              name: 'home',
              component: Home,
              meta: {
                forVisitors: true,
                simpleHeader: true
              }
            },
            {
              path: '*',
              component: PageNotFound,
              meta: {
                simpleHeader: true,
                statusCode: 404
              }
            }
          ]
        }
      ]
    }
  ],
  mode: 'history',
  scrollBehavior (to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    } else {
      return { x: 0, y: 0 }
    }
  }
})



// WEBPACK FOOTER //
// ./src/router/router.js